export default __webpack_public_path__ + "static/media/fala 4.afe946ac.png";